import { render } from "./PartB.vue?vue&type=template&id=b2b7d940"
import script from "./PartB.vue?vue&type=script&lang=js"
export * from "./PartB.vue?vue&type=script&lang=js"

import "./PartB.vue?vue&type=style&index=0&id=b2b7d940&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__